import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { type Observable } from 'rxjs';
import { loadCartIcon, saveCartIcon, setChangedState } from './shop-cart-icon.actions';
import {
    selectCartIconData,
    selectIsCartEnabled,
    selectCartIconLoading,
    selectIconPositionType,
    selectCartSettingsChanged,
} from './shop-cart-icon.selectors';
import type { ShopCartIconSettingsType } from '@common/types/shop-cart-icon-settings.type';

@Injectable({
    providedIn: 'root',
})
export class ShopCartIconFacade {
    private store = inject(Store);

    cartIconData$: Observable<ShopCartIconSettingsType | null> = this.store.select(selectCartIconData);
    cartIconDataStream$: Observable<ShopCartIconSettingsType | null> = this.store.select(selectCartIconData);
    isCartEnabled$: Observable<boolean> = this.store.select(selectIsCartEnabled);
    iconPositionType$: Observable<string> = this.store.select(selectIconPositionType);
    isCartSettingsChanged$: Observable<boolean> = this.store.select(selectCartSettingsChanged);
    loading$: Observable<boolean> = this.store.select(selectCartIconLoading);

    public loadCartIcon(siteId: string): void {
        this.store.dispatch(loadCartIcon({ siteId }));
    }

    public saveCartIcon(data: ShopCartIconSettingsType): void {
        this.store.dispatch(saveCartIcon({ data }));
    }

    public setChangedState(isChanged: boolean): void {
        this.store.dispatch(setChangedState({ isChanged }));
    }
}
